import PropTypes from "prop-types";
import React, { useState } from "react";
import Button from "@material-ui/core/Button";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import Typography from "@material-ui/core/Typography";
import Alert from "@material-ui/lab/Alert";
import { useDispatch, useSelector } from "react-redux";
import { setSocialSecurityFunc } from "../utils/fetcher";
import { translator } from "../utils/i18n";
import { Box, Icon, TextField } from "@material-ui/core";
import { Trans } from "@lingui/macro";

export default function SocialSecurityDialog(props) {
  const dispatch = useDispatch();
  const NbrSocialSecurity = useSelector(state => state.socialSecurity);
  const [securityId, setSecurityId] = useState(
    props.currentPatientInfo.num_securite_sociale_user
  );
  const [address, setAddress] = useState(props.currentPatientInfo.adresse_user);
  const [codePostal, setCodePostal] = useState(
    props.currentPatientInfo.code_postal_user
  );
  const [ville, setVille] = useState(props.currentPatientInfo.ville_user);
  const [medecinTraitant, setMedecinTraitant] = useState(
    props.currentPatientInfo.medecin_traitant_user
  );
  const [alertSecurityId, setAlertSecurityId] = useState(false);
  const [alertAddr, setAlertAddr] = useState(false);
  const [alertCP, setAlertCP] = useState(false);
  const [alertVille, setAlertVille] = useState(false);
  const [alertMT, setAlertMT] = useState(false);

  const MASK_SECID = "9 99 99 99 999 999 99";
  const MASK_CP = "99 999";

  const handleSave = e => {
    e.preventDefault();

    if (checkParameters(props.infoNewForm)) {
      dispatch(
        setSocialSecurityFunc(
          securityId?.replace(/\s/g, ""),
          props.patientId,
          address,
          codePostal,
          ville,
          medecinTraitant
        )
      );
    }
    goToPrevious();
  };

  const checkParameters = infoNewForm => {
    var result = true;

    if (infoNewForm.b_activ_adresse && !checkAddr()) {
      result = false;
    }

    if (infoNewForm.b_activ_medecin_traitant && !checkMT()) {
      result = false;
    }

    if (props.isRequiredSocialSecurity && !checkSecId()) {
      result = false;
    }

    return result;
  };

  const checkParam = (param, setAlertParam, alertParam, mask) => {
    var result = true;

    if (
      !param ||
      param === "" ||
      (mask &&
        param.replace(/\s/g, "").length !== mask.replace(/\s/g, "").length)
    ) {
      setAlertParam(true);
      result = false;
    } else if (alertParam) {
      setAlertParam(false);
    }

    return result;
  };

  const checkMT = () => {
    var result = true;
    result = result && checkParam(medecinTraitant, setAlertMT, alertMT);
    return result;
  };

  const checkAddr = () => {
    var result = true;

    result = checkParam(address, setAlertAddr, alertAddr) && result;
    result = checkParam(codePostal, setAlertCP, alertCP, MASK_CP) && result;
    result = checkParam(ville, setAlertVille, alertVille) && result;

    return result;
  };

  const checkSecId = () => {
    var result = true;

    result = checkParam(
      securityId,
      setAlertSecurityId,
      alertSecurityId,
      MASK_SECID
    );

    return result;
  };

  const goToPrevious = () => {
    props.closeDialog();
  };

  return (
    <>
      <form>
        <Card variant="outlined" style={{ border: "none" }}>
          <div
            className="title_dialog_header_social_security"
            dangerouslySetInnerHTML={{
              __html: translator()._("W_MSG_HEADER_SOCIAL_SECURITY_DIALOG")
            }}
          />
          {props.isRequiredSocialSecurity && (
            <CardContent className="no-padding-left no-padding-right ">
              <Typography className="mat_dialog_text">
                {translator()._("W_LABEL_SECURITE_SOCIALE")}
              </Typography>
              {NbrSocialSecurity === 2 && (
                <Alert severity="error">
                  {translator()._("W_MESSAGE_NON_VALID_NUM_SECURITE_SOCIALE")}
                </Alert>
              )}
              <TextField
                className="input-custom"
                name="medecinTraitant"
                id="outlined-basic"
                label={translator()._("W_MON_ADRESS")}
                variant="outlined"
                value={address}
                onChange={e => setAddress(e.target.value)}
                error={
                  alertSecurityId &&
                  translator()._("W_CE_CHAMP_EST_OBLIGATOIRE")
                }
              />
              <TextField
                className="input-custom"
                name="medecinTraitant"
                id="outlined-basic"
                label={translator()._("W_MON_ADRESS")}
                variant="outlined"
                value={securityId}
                onChange={e => setSecurityId(e.target.value)}
                error={
                  alertSecurityId &&
                  translator()._("W_CE_CHAMP_EST_OBLIGATOIRE")
                }
              />
            </CardContent>
          )}
          {props.infoNewForm.b_activ_adresse && (
            <>
              <CardContent className=" no-padding-left no-padding-right ">
                <TextField
                  className="input-custom"
                  name="medecinTraitant"
                  id="outlined-basic"
                  label={translator()._("W_MON_ADRESS")}
                  variant="outlined"
                  value={address}
                  onChange={e => setAddress(e.target.value)}
                  error={
                    alertAddr && translator()._("W_CE_CHAMP_EST_OBLIGATOIRE")
                  }
                />
              </CardContent>
              <CardContent className=" no-padding-left no-padding-right ">
                <div className="line-form">
                  <div style={{ paddingBottom: 30 }}>
                    <TextField
                      className="input-custom"
                      name="medecinTraitant"
                      id="outlined-basic"
                      label={translator()._("W_STEP4_FORMULAIRE_CODE_POSTAL")}
                      variant="outlined"
                      value={codePostal}
                      onChange={e => setCodePostal(e.target.value)}
                      error={
                        alertCP && translator()._("W_CE_CHAMP_EST_OBLIGATOIRE")
                      }
                    />
                  </div>
                  <div style={{ paddingBottom: 30 }}>
                    <TextField
                      className="input-custom"
                      name="medecinTraitant"
                      id="outlined-basic"
                      label={translator()._("W_STEP4_FORMULAIRE_VILLE")}
                      variant="outlined"
                      value={ville}
                      onChange={e => setVille(e.target.value)}
                      error={
                        alertVille &&
                        translator()._("W_CE_CHAMP_EST_OBLIGATOIRE")
                      }
                    />
                  </div>
                </div>
              </CardContent>
            </>
          )}
          {props.infoNewForm.b_activ_medecin_traitant && (
            <CardContent className=" no-padding-left no-padding-right ">
              <TextField
                className="input-custom"
                name="medecinTraitant"
                id="outlined-basic"
                label={translator()._("W_RELATION_MEDECIN_TRAITANT")}
                variant="outlined"
                value={medecinTraitant}
                onChange={e => setMedecinTraitant(e.target.value)}
                error={alertMT && translator()._("W_CE_CHAMP_EST_OBLIGATOIRE")}
              />
            </CardContent>
          )}
        </Card>
      </form>
      <Box
        style={{
          display: "flex",
          marginBottom: -80,
          marginTop: 50,
          justifyContent: "end"
        }}
      >
        <Button
          onClick={handleSave}
          className="btn-filled"
          color="primary"
          variant="contained"
        >
          <span className="text">
            {<Trans id={"W_STEP_BOUTON_CONTINUER"} />}
          </span>
          <Icon>arrow_forward</Icon>
        </Button>
      </Box>
    </>
  );
}

SocialSecurityDialog.propTypes = {
  closeDialog: PropTypes.func,
  currentPatientInfo: PropTypes.shape({
    adresse_user: PropTypes.string,
    code_postal_user: PropTypes.string,
    medecin_traitant_user: PropTypes.string,
    num_securite_sociale_user: PropTypes.string,
    ville_user: PropTypes.string
  }),
  infoNewForm: PropTypes.shape({
    b_activ_adresse: PropTypes.bool,
    b_activ_medecin_traitant: PropTypes.bool
  }),
  isRequiredSocialSecurity: PropTypes.bool,
  patientId: PropTypes.any
};
